
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'TripRecordStatusMessageComponent',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: false
    }
  },
  emits: [],
  methods: {},
  components: {},
  setup() {
    return {}
  }
})
